import CreationBody from 'components/CreateQuiz/CreationBody';

const Tablet = () => <CreationBody device={'tablet'} />;

export default Tablet;
